import { useEffect } from "react";

const SITE_URL = "https://thrivebahamas.com";

const setMeta = (selector, create, content) => {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    Object.entries(create).forEach(([k, v]) => tag.setAttribute(k, v));
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export const SEO = ({ title, description, jsonLd }) => {
  useEffect(() => {
    const path = window.location.pathname;
    const url = `${SITE_URL}${path === "/" ? "" : path}`;

    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', { property: "og:title" }, title);
      setMeta('meta[name="twitter:title"]', { name: "twitter:title" }, title);
    }
    if (description) {
      setMeta('meta[name="description"]', { name: "description" }, description);
      setMeta('meta[property="og:description"]', { property: "og:description" }, description);
      setMeta('meta[name="twitter:description"]', { name: "twitter:description" }, description);
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
    setMeta('meta[property="og:url"]', { property: "og:url" }, url);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, jsonLd]);
  return null;
};
